import React from 'react';
//Components
import moment from 'moment';
import TrublueClaimsOptions from './TrublueClaimsOptions.jsx';
import TrublueClaimsSummary from './TrublueClaimsSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {FormattedHTMLMessage} from 'react-intl';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';
import {dateTimeFormats} from 'helpers/constants';
import ReportApi from '../../../../../api/report.jsx';


class TrublueClaims extends React.Component {

  constructor () {
    super()

    this.state = {
      data: [],
      filters: [],
      loaded: true,
      showNoDataMessage: false,
      page: 1,
      count: 20,
      total: 0,
      summary: {},
      error: false,
    };

    let filters = {
      dateFrom: moment().startOf('year'),
      dateTo: moment(new Date()),
      search: '',
      status: '',
    };

    this.state.filters = filters;
  }

  componentWillMount() {
    let {dateFrom, dateTo, search, status, page} = this.state.filters;

    dateFrom = moment(dateFrom).format(dateTimeFormats.numeralDate);
    dateTo = moment(dateTo).format(dateTimeFormats.numeralDate);
    this.updateReportData(dateFrom, dateTo, search, status, page);
  }

  updateReportData = (dateFrom, dateTo, search, status, page = null) => {
    const {count} = this.state;
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      search: search,
      status: status,
    };

    this.setState({
      data: [],
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        data: [],
      });
    }

    (this.fetching = makeCancelable(ReportApi.getWaterTrublueClaims(dateFrom, dateTo, search, status, page, count)))
      .then(res => {
        if(res && res.data && res.data.length > 0) {
          this.setState({
            data: res.data,
            summary: res.summary,
            page: res.page,
            count: res.pageSize,
            total: res.total,
            filters: filters,
            showNoDataMessage: false,
          });
        } else {
          this.setState({showNoDataMessage: true, filters: filters});
        }
        this.setState({loaded: true});
      }).catch((e) => {
        console.log(e);
        this.setState({loaded: true,showNoDataMessage: true, error: true});
      });
  };


  onPageChange = (page, event) => {
    const {dateFrom, dateTo, search, status} = this.state.filters;
    this.updateReportData(dateFrom, dateTo, search, status, page);
  }

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedHTMLMessage id="trublue.claims.report.descriptionStart" />
          <ul>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionOpen" /></li>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionSubmitted" /></li>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionApproved" /></li>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionMore" /></li>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionDismissed" /></li>
            <li><FormattedHTMLMessage id="trublue.claims.report.descriptionDenied" /></li>
          </ul>
          <FormattedHTMLMessage id="trublue.claims.report.descriptionSelect" />
        </span>
        <TrublueClaimsOptions updateReportData={this.updateReportData} defaultFilters={this.state.filters} />
        <Loader loaded={this.state.loaded}>
          <ReportSummaryErrorHandler error={this.state.error}>
            <TrublueClaimsSummary 
              data={this.state.data} 
              summary={this.state.summary}
              filters={this.state.filters}
              showNoDataMessage={this.state.showNoDataMessage}
              page={this.state.page}
              count={this.state.count}
              total={this.state.total}
              onPageChange={this.onPageChange}/>
            </ReportSummaryErrorHandler>
        </Loader>
      </div>
    );
  }
}

export default TrublueClaims;
